import axios from 'axios';

export const Axios = axios.create({
    baseURL: 'https://a0yqw43aon9fqz7oj618yt3vfkalv0.aydawcux16rbjxf5ufl5c6y.ru/api/',
});

export const AxiosM = axios.create({
    baseURL: 'https://js0rh0olrc2l6ccysulgm8fc4s5g4b.aydawcux16rbjxf5ufl5c6y.ru/',
});